import type { Translations } from '~/utils/translations/types';

const it: Translations = {
  apply: {
    congrat_1_steps: '1. Scansiona il codice QR dalla fotocamera del tuo smartphone',
    congrat_2_steps: "2. Scarica l'app e completa il tuo profilo",
    congrat_3_steps: '3. Resta aggiornato sulle offerte vicino a te!',
    download_app: 'Scarica',
    form_address_label: 'Indirizzo',
    form_address_placeholder: 'Via Archimede, 22, 20129 Milano MI',
    form_email_label: 'E-mail',
    form_email_placeholder: 'johndoe@iziwork.com',
    form_email_placeholder_pm: 'johndoe@iziwork.com',
    form_firstname_label: 'Nome',
    form_firstname_placeholder: 'Ludovica',
    form_lastname_label: 'Cognome',
    form_lastname_placeholder: 'Rossi',
    form_phone_label: 'Telefono',
    form_phone_placeholder: '+39 340 636 3636',
    form_resume_button: 'Importare',
    form_resume_label: 'CV',
    form_resume_label_pstf: 'CV',
    message_info_accept_conditions: ". Puoi visionare l'informativa sulla privacy ",
    message_info_accept_tcu: 'Continuando, accetti i',
    modal_action_apply: 'Candidati',
    modal_action_close: 'Chiudi',
    step_unknown: {
      dropzone: {
        drop: 'Trascina e rilascia o ',
        select: 'seleziona il tuo file',
        supported_files: 'File supportati: PDF, DOC, DOCX',
      },
    },
    subtitle_download_app: 'Scarica la nostra app per monitorare la tua candidatura.',
    subtitle_email_to_identify: 'La tua email ci consente di identificare se ci conosciamo già.',
    subtitle_resume_to_apply: 'Abbiamo bisogno del tuo CV e dei dettagli di contatto per elaborare la tua candidatura.',
    subtitle_resume_to_apply_pstf:
      'Abbiamo bisogno del tuo CV e dei dettagli di contatto per elaborare la tua candidatura.',
    tcu_conditions: 'qui',
    tcu_confidentiality: 'Termini di servizio',
    title_congratulation: 'Ben fatto, la tua candidatura è stata inviata!',
    title_free_apply: 'Candidarsi per una missione',
    title_job_offer_apply: 'Candidati per questa offerta lavorativa',
    title_you_are_new: 'Non ci conosciamo ancora!',
  },
  banner: {
    join_community: 'Unisciti alla community <span>{{name}}</span>',
    large_choice: 'Ampia varietà di offerte',
    large_choice_desc:
      "Seleziona il lavoro che preferisci da un'ampia varietà di offerte vicino a te (in somministrazione, tempo determinato e indeterminato)",
    personal_service: 'Supporto tempestivo e personalizzato',
    personal_service_desc:
      'Ricevi quotidianamente il supporto di cui hai bisogno grazie al team di assistenza. Più lavori con iziwork, più vantaggi ottieni!',
    personal_service_desc_pm:
      'Ricevi quotidianamente il supporto di cui hai bisogno grazie al team di assistenza. Più lavori con Proman Solutions, più vantaggi ottieni!',
    simple_and_fast: 'Semplice e veloce',
    simple_and_fast_desc:
      "Aggiorna il tuo cv direttamente nell'app di iziwork e candidati alle offerte che ti interessano in soli 3 click",
  },
  breadcrumbs: {
    home: 'Home',
  },
  buttons: {
    contact_us: 'Contattaci',
    load_more: 'Vedi altro',
  },
  cities_page: {
    meta_description:
      'Trova le nostre offerte di lavoro in somministrazione, a tempo determinato e indeterminato nella tua città e candidati in pochi clic.',
    meta_title: 'Le nostre offerte di lavoro per città - iziwork',
    title: 'Tutte le città',
  },
  city_job_page: {
    heading: 'Lavora come {{job}} a {{city}}',

    latest_job_offers: 'Le nostre ultime offerte di lavoro {{job}} a {{city}}',
    meta_description:
      'Offerte di lavoro temporaneo, a tempo determinato e indeterminato per {{job}} a {{city}}: candidati online in pochi clic',
    meta_title: 'Le nostre offerte di lavoro per {{job}} a {{city}} - iziwork',
    title: 'Le nostre offerte di lavoro <span>{{job}}</span> a <span>{{city}}</span>',
  },
  city_page: {
    heading: 'Lavora a {{city}}',
    latest_job_offers: 'Le nostre ultime offerte a {{city}}',
    meta_description:
      'Offerte di lavoro temporaneo, a tempo determinato e indeterminato a {{city}}: addetto al prelievo ordini, carrellista, magazziniere... Candidati con iziwork.',
    meta_title: 'Le nostre offerte di lavoro a {{city}} - iziwork',
    title: 'Le nostre offerte a <span>{{city}}</span>',
  },
  consent_manager: {
    content:
      'Utilizziamo le informazioni raccolte dai cookie per migliorare la tua esperienza di navigazione e consentirti di visualizzare annunci personalizzati e aumentare le prestazioni del nostro sito.',
    title: 'Gestisci le mie preferenze',
  },
  date: {
    today: 'oggi',
  },
  error_pages: {
    internal_server_error_title: 'Spiacente, si è verificato un errore ...',
    not_found_subtitle1: 'Ma non preoccuparti, i nostri sviluppatori ci stanno lavorando!',
    not_found_subtitle2: 'Torna alla Home Page finchè il problema non è risolto',
    not_found_title: 'Oops, sembra che la pagina che stavi visualizzando sia scomparsa.',
    redirect_label: 'Tornare nella Home Page',
  },
  expired_job_offer: {
    meta_title: 'Offerta scaduta: {{title}} a {{city}}',
    meta_title_without_city: 'Offerta scaduta: {{title}}',
    subtitle: "L'offerta {{title}} a {{city}} è stata assegnata o ritirata. Scopri altre offerte vicino a te.",
    subtitle_without_city: "L'offerta {{title}} è stata assegnata o ritirata. Scopri altre offerte vicino a te.",
    title: 'Questa offerta non è più disponibile',
  },
  field_errors: {
    address_valueIncomplete: "L'indirizzo è incompleto",
    address_valueMissing: "L'indirizzo è obbligatorio",
    captcha_valueMissing: 'Il campo è obbligatorio',
    email_typeMismatch: "L'email non è corretta",
    email_valueMissing: 'E-mail è obbligatoria',
    firstname_valueMissing: 'Il nome è obbligatorio',
    lastname_valueMissing: 'Il cognome è obbligatorio',
    phone_typeMismatch: 'Il telefono non è corretto',
    phone_valueMissing: 'Il telefono è obbligatorio',
    resume_invalidSize: 'La dimensione del file deve essere compresa tra 1 KB e 10 MB',
    resume_invalidType: 'Il tipo di file non è valido',
    resume_valueMissing: 'Il CV è obbligatorio',
    resume_valueMissing_pstf: 'Il CV è obbligatorio',
  },
  footer: {
    aboutUs: 'Chi siamo',
    account: 'Accedi',
    askADemo: 'Richiedi una demo',
    blog: 'Blog',
    companies: 'Aziende',
    companySpace: 'Spazio commerciale',
    confidentiality: 'Politica sulla riservatezza',
    cookies_policy: 'Politica sui cookie',
    cookies_settings: 'Impostazioni dei cookie',
    join: 'Unisciti a noi',
    legal_mentions: 'Avviso legale',
    partners: 'Partner',
    personalData: 'Dati personali',
    press: 'Area stampa',
    program: 'Programma partner',
    rgpd: 'I tuoi diritti ai sensi del GDPR',
    sitemap: 'Mappa del sito',
    socialMedia: {
      facebook: 'Seguici su Facebook',
      instagram: 'Guarda le nostre storie su Instagram',
      linkedin: 'Aggiungici su LinkedIn',
      twitter: 'Guarda le nostre storie su Twitter',
    },
    usage_conditions: 'Termini di utilizzo',
    usage_conditions_pm: 'Termini di utilizzo',
    who: 'Chi siamo?',
    why: 'Perché Iziwork?',
    worker: 'Lavoratori',
  },
  form_errors: {
    address: 'Seleziona una città',
    job: 'Inserisci un lavoro',
  },
  form_labels: {
    address: 'Città',
    address_pstf: 'Città',
    distance: '< {{distance}} km',
    experience: 'Esperienza richiesta',
    job: 'Lavoro',
    sort: 'Ordina per',
    type: 'Tipo di contratto',
  },
  form_option_labels: {
    experience: {
      all: 'Tutte',
      any: 'Almeno 1 giorno',
      five_years: 'Più di 5 anni',
      none: 'Nessuna esperienza richiesta',
      one_month: 'Almeno 1 mese',
      one_year: 'Almeno 1 anno',
      six_months: 'Almeno 6 mesi',
      three_months: 'Almeno 3 mesi',
      two_years: 'Tra 2 e 5 anni',
    },
    sort: {
      publication: 'Data di pubblicazione',
      relevance: 'Rilevanza',
    },
    type: {
      all: 'Tutti',
      contract: 'Tempo determinato',
      non_seasonal_temporary: 'Somministrazione',
      permanent: 'Tempo indeterminato',
      permanent_pstf: 'Assunzione diretta',
      seasonal_temporary: 'Somministrazione',
      temporary: 'Somministrazione',
      temporary_pstf: 'Somministrazione',
    },
    urgent: 'Urgente',
  },
  form_option_values: {
    experience: {
      any: 'primo',
      five_years: '5 anni e oltre',
      none: 'nessuno',
      one_month: '1 mese',
      one_year: '1 anno',
      six_months: '6 mesi',
      three_months: '3 mesi',
      two_years: '2 anni e oltre',
    },
    sort: {
      publication: 'pubblicazione',
      relevance: 'rilevanza',
    },
    type: {
      contract: 'determinato',
      non_seasonal_temporary: 'somministrazione',
      permanent: 'indeterminato',
      seasonal_temporary: 'somministrazione',
      temporary: 'somministrazione',
    },
  },
  form_placeholders: {
    address: 'Cerca una città',
    address_pstf: 'Cerca una città',
    job: 'Cerca un lavoro',
    type: 'Cerca un tipo di contratto',
  },
  form_title: 'La tua ricerca',
  free_application_card: {
    button: 'Andiamo',
    message: 'Invia il tuo CV e ti contatteremo non appena troveremo un lavoro adatto a te.',
    title: 'Cerchi lavoro?',
  },
  header: {
    findMission: 'Trova lavoro',
    myApply: 'Le mie candidature',
    partners: 'Recensioni aziendali',
  },
  home_page_offers: {
    buttons: {
      cities: 'Scopri tutte le città',
      sectors: 'Scopri tutti i settori',
    },
    title_1: '<span>{{formattedCount}}</span> offerta di lavoro in tutta Italia',
    title_other: '<span>{{formattedCount}}</span> offerte di lavoro in tutta Italia',
  },
  job_page: {
    heading: 'Lavora come {{job}}',
    latest_job_offers: 'Le nostre ultime offerte di lavoro {{job}}',
    meta_description:
      'Offerte di lavoro temporaneo, a tempo determinato e indeterminato per la professione di {{job}}: candidati online in pochi clic',
    meta_title: 'Le nostre offerte di lavoro per {{job}} - iziwork',
    title: 'Le nostre offerte di lavoro <span>{{job}}</span>',
  },
  jobs_page: {
    meta_description:
      'Magazziniere, addetto alle vendite, operaio di produzione… Trova le nostre offerte di lavoro per professione e candidati in pochi clic.',
    meta_title: 'Le nostre offerte di lavoro per professione - iziwork',
    title: 'Tutte le professioni',
  },
  latest_job_offers: {
    page: 'Pagina {{page}}',
    title: 'Le nostre ultime offerte',
  },
  list_grid_layout: {
    cities: {
      title: 'Le nostre offerte per città',
    },
    jobs: {
      title: 'Le nostre offerte per professione',
    },
    sectors: {
      title: 'Le nostre offerte per settore',
    },
  },
  menu: {
    b2b_button: "Sono un'azienda",
    cities: 'Città',
    entreprise_button_mobile: 'Azienda',
    jobs: 'Professioni',
    link: {
      cities: 'Visualizza tutte le città',
      jobs: 'Visualizza tutte le professioni',
      sectors: 'Visualizza tutti i settori',
    },
    sectors: 'Settori di attività',
  },
  meta_description: {
    jobOffer: {
      default: "Dai un'occhiata a questa offerta come {{title}} a {{city}}.",
      suffix: 'Candidati in 3 clic ora, lavora domani!',
      type: {
        contract: "Dai un'occhiata a questa offerta in Tempo Determinato come {{title}} a {{city}}.",
        permanent: "Dai un'occhiata a questa offerta in Tempo Indeterminato come {{title}} a {{city}}.",
        temporary: "Dai un'occhiata a questa offerta in Somministrazione come {{title}} a {{city}}.",
      },
    },
  },
  meta_social_description: {
    mission_description:
      "Dai un'occhiata alla nostra offerta da {{displayName}} vicino a {{city}} . Candidati in 3 clic ora, lavora domani!",
    mission_title: '{{displayName}} - {{city}} ( {{areaCode}} ) - Offerta di lavoro',
    partner_description: 'Decine di posizioni disponibili vicino a {{city}}! Candidatura facile e veloce.',
    partner_title: 'Offriamo opportunità di lavoro vicino a {{city}} ({{areaCode}})',
  },
  missions: {
    about: 'Descrizione mansione',
    apply: 'Candidati',
    back: 'Torna alla ricerca',
    bonuses: 'Benefits',
    certificates: 'Certificati',
    close_distance: 'vicino',
    contractType: 'Tipo di contratto',
    details_tab_label: 'Dettagli',
    distance: '{{distance}} km di distanza',
    experience: 'Esperienza',
    informations: 'Dettagli',
    location: 'Luogo',
    mission_h1: {
      with_area: '{{title}} a {{city}} ({{areaCode}})',
      without_area: '{{title}} a {{city}}',
    },
    mission_title: {
      with_area: '{{title}} a {{city}} ({{areaCode}}) - Offerta di lavoro',
      without_area: '{{title}} a {{city}} - Offerta di lavoro',
    },
    no_certificates_required: 'Nessun certificato richiesto',
    no_experience_required: 'Nessuna esperienza richiesta - giovani, lavoratori non qualificati... accettati',
    no_experience_required_pstf: 'Nessuna esperienza richiesta - giovani, lavoratori non qualificati... accettati',
    profile: 'Prerequisiti',
    published: 'Pubblicato ',
    remuneration: 'Retribuzione',
    see_all_missions: 'Vedi tutte le sue offerte',
    see_all_offers: 'Vedi tutte le offerte',
    weekly_hours: {
      default: '{{hours}} ore settimanali',
      hours: '{{hours}} ore',
      per_week: 'settimanali',
    },
    workTime: 'Tempo di lavoro',
  },
  no_mission_modal: {
    button: {
      close: 'Chiudi',
      next: 'Avanti',
    },
    download_app: "Scarica subito l'app iziwork!",
    download_app_pm: "Scarica subito l'app Proman Solutions!",
    download_app_subtitle: 'Registrati e completa il tuo profilo in 5 minuti grazie al nostro sistema di analisi CV.',
    download_app_subtitle_pstf:
      'Registrati e completa il tuo profilo in 5 minuti grazie al nostro sistema di analisi CV.',
    placeholder: {
      email: 'Il tuo indirizzo email',
      phone: 'Il tuo numero di telefono',
    },
    step: 'Passo {{step}} / 2',
    subtitle:
      'Siamo costantemente alla ricerca delle migliori opportunità per te! Inserisci i tuoi dati e ti informeremo non appena avremo offerte da proporti:',
    success: {
      body: 'Registrati e completa il tuo profilo in 5 minuti utilizzando il nostro sistema di analisi CV.',
      body_pstf: 'Registrati e completa il tuo profilo in 5 minuti utilizzando il nostro sistema di analisi CV.',
      subtitle: 'Ci sei quasi!',
      title: 'Scopri le nostre offerte nella nostra applicazione',
    },
    title: 'Spiacente, sembra che non sia stata trovata alcuna offerta!',
  },
  no_missions_result: {
    download_app: "Scarica subito l'app iziwork!",
    download_app_pm: "Scarica subito l'app Proman Solutions!",
    download_hint: "Scarica l'applicazione e ti informeremo non appena avremo offerte da offrirti.",
    subtitle: 'Siamo costantemente alla ricerca delle migliori opportunità per te!',
    title: 'Spiacente, sembra che non siano state trovate offerte!',
  },
  pain_points_page: {
    meta_description:
      'Reclutamento, profili introvabili, conformità, gestione amministrativa, fidelizzazione: le risposte di iziwork alle sfide del lavoro in somministrazione.',
    meta_title: 'Le vostre sfide di reclutamento - iziwork',
    title: 'Problemi',
  },
  salary: {
    gross_per_unit: {
      hourly: 'lordi/ora',
      hourly_pstf: 'lordi/ora',
      monthly: 'lordi/mese',
      monthly_pstf: 'lordi/mese',
      yearly: 'lordi/anno',
      yearly_pstf: 'lordi/anno',
    },
  },
  search_button: {
    label: 'Cerca',
  },
  search_params: {
    address: 'citta',
    distance: 'distanza',
    experience: 'esperienza',
    job: 'lavoro',
    page: 'pagina',
    sort: 'ordina',
    type: 'contratto',
  },
  sector_page: {
    heading: 'Lavora nel settore {{sector}}',
    latest_job_offers: 'Le nostre ultime offerte nel settore {{sector}}',
    meta_description:
      '{{sector}}: offerte di lavoro temporaneo, a tempo determinato e indeterminato nella tua città. Candidati online o con la nostra app.',
    meta_title: 'Settore {{sector}}: offerte di lavoro - iziwork',
    title: 'Le nostre offerte nel settore <span>{{sector}}</span>',
  },
  sectors_page: {
    meta_description:
      'Logistica, industria, ristorazione… Trova le nostre offerte di lavoro per settore di attività e candidati in pochi clic.',
    meta_title: 'Le nostre offerte di lavoro per settore - iziwork',
    title: 'Tutti i settori di attività',
  },
  similar_offers: {
    title_nearby: 'Altre offerte vicino a {{city}}',
    title_with_location: 'Altre offerte per {{title}} a {{city}}',
    title_without_city: 'Altre offerte nelle vicinanze',
  },
  sitemap_page: {
    meta_description:
      'Mappa del sito iziwork: tutte le nostre offerte di lavoro temporaneo, a tempo determinato e indeterminato, per città, professione e settore.',
    meta_title: 'Mappa del sito - iziwork',
    title: 'Mappa del sito',
  },
  solutions_page: {
    meta_description:
      'Onsite, central staffing, matching automatico: le soluzioni iziwork per reclutare e gestire i lavoratori in somministrazione su tutti i vostri siti.',
    meta_title: 'Le nostre soluzioni di reclutamento per le aziende - iziwork',
    title: 'Soluzioni',
  },
  tags: {
    experience: {
      any: 'Almeno 1 giorno',
      five_years: 'Più di 5 anni di esperienza',
      none: 'Nessuna esperienza richiesta',
      one_month: 'Almeno 1 mese di esperienza',
      one_year: 'Almeno 1 anno di esperienza',
      six_months: 'Almeno 6 mesi di esperienza',
      three_months: 'Almeno 3 mesi di esperienza',
      two_years: 'Tra 2 e 5 anni di esperienza',
    },
  },
  title: {
    '404_error': 'Pagina non trovata - offerte di lavoro iziwork',
    '404_error_pm': 'Pagina non trovata - offerte di lavoro Proman Solutions',
    '404_error_pstf': 'Pagina non trovata - offerte di lavoro Proman Staffing',
    '500_error': 'Errore sconosciuto - offerte di lavoro iziwork',
    '500_error_pm': 'Errore sconosciuto - offerte di lavoro Proman Solutions',
    '500_error_pstf': 'Errore sconosciuto - offerte di lavoro Proman Staffing',
  },
  toasts: {
    application_error_body: 'La tua candidatura non è stata presa in considerazione, riprova più tardi.',
    application_error_title: "C'è stato un errore",
    install_app_sms_error_body: 'La tua richiesta non è stata presa in considerazione, riprova più tardi.',
  },
  url: {
    askADemo: 'assunzioni-interim',
    blog: 'il-nostro-blog',
    companySpace: 'aziende',
    confidentiality: 'informativa-sulla-privacy',
    cookie: 'politique-des-cookies',
    legalMentions: 'note-legali',
    partners: 'partners',
    personalData: 'modulo-per-i-diritti-di-esercizio',
    press: 'stampa',
    usageConditions: 'condizioni-generali-utilizzo',
    usageConditions_pstf: 'condizioni-generali-utilizzo',
    who: 'chi-siamo',
    why: 'perche-iziwork',
  },
  welcome: 'Benvenuto',
  welcome_page: {
    meta_description:
      "Migliaia di offerte di lavoro online o sull'app di iziwork, l'agenzia per il lavoro digitale #1. Trova una missione vicino a te e candidati in 3 clic.",
    meta_description_pm:
      'Offerte di lavoro in somministrazione, a tempo determinato e indeterminato di Proman Solutions. Trova una missione vicino a te e candidati online.',
    meta_description_pstf:
      'Le offerte di lavoro di Proman Staffing: posizioni temporanee e a tempo indeterminato vicino a te. Candidati online in pochi clic.',
    meta_description_search_city:
      'Offerte di lavoro in somministrazione, a tempo determinato e indeterminato intorno a {{city}}: candidati online in pochi clic.',
    meta_description_search_job:
      'Offerte di lavoro come {{job}}: somministrazione, tempo determinato e indeterminato. Candidati in pochi clic.',
    meta_description_search_job_city:
      'Offerte di lavoro come {{job}} intorno a {{city}}: somministrazione, tempo determinato e indeterminato.',
    meta_social_description: 'Offerte di lavoro vicino a te! Applicazione facile e veloce.',
    meta_social_description_city: 'Offerte vicino a {{city}} ! Applicazione facile e veloce.',
    meta_social_title: 'Accedi alle nostre offerte di lavoro intorno a te',
    meta_social_title_city: 'Le nostre offerte di lavoro vicino a {{city}}',
    meta_social_title_city_zipcode: 'Le nostre offerte di lavoro vicino a {{city}} ({{zipcode}})',
    meta_title: 'Le nostre offerte di lavoro - iziwork',
    meta_title_city: '{{city}} - Le nostre offerte di lavoro - iziwork',
    meta_title_city_pm: '{{city}} - Le nostre offerte di lavoro - Proman Solutions',
    meta_title_city_pstf: '{{city}} - Le nostre offerte di lavoro - Proman Staffing',
    meta_title_city_zipcode: '{{city}} ({{zipcode}}) - Le nostre offerte di lavoro - iziwork',
    meta_title_city_zipcode_pm: '{{city}} ({{zipcode}}) - Le nostre offerte di lavoro - Proman Solutions',
    meta_title_city_zipcode_pstf: '{{city}} ({{zipcode}}) - Le nostre offerte di lavoro - Proman Staffing',
    meta_title_pm: 'Le nostre offerte di lavoro - Proman Solutions',
    meta_title_pstf: 'Offerte di lavoro vicino a te - Proman Staffing',
    missions_available_0: 'Nessuna offerta disponibile',
    missions_available_1: '1 offerta di lavoro trovata',
    missions_available_other: '{{count}} offerte di lavoro trovate',
    title: 'Le nostre<br>offerte vicino <span>a te!</span>',
  },
};

export default it;
